// extracted by mini-css-extract-plugin
export default {"wrapper":"StubPage_wrapper__BUvCW","fadeUp":"StubPage_fadeUp__jXG5V","icon":"StubPage_icon__qJ8QE","title":"StubPage_title__hBpVh","desc":"StubPage_desc__dYpeN"};